(function ($) {
  const newsContainer = $("#news-container");
  const paginationContainer = $("#news-pagination");
  const newsLoader = $(".news-loader");
  let currentPage = 1;
  const perPage = 12;
  let isLoading = false;
  let isFirstLoad = true; // Variable para controlar si es la primera carga

  // Función para cargar noticias
  function loadNews(page = 1) {
    if (isLoading) return;
    isLoading = true;

    // Mostrar indicador de carga solo en la primera carga
    if (isFirstLoad) {
      newsLoader.show();
    }
    newsContainer.addClass("loading");
    $.ajax({
      url: toledano_vars.ajaxurl,
      type: "POST",
      data: {
        action: "load_news",
        page: page,
        per_page: perPage
      },
      success: function (response) {
        if (response.success) {
          // Actualizar el contenido
          newsContainer.html(response.news_html);
          paginationContainer.html(response.pagination_html);

          // Actualizar la página actual
          currentPage = response.current_page;

          // Marcar que ya no es la primera carga
          isFirstLoad = false;
        } else {
          console.error("Error al cargar noticias");
          newsContainer.html('<p class="error-message">Ha ocurrido un error al cargar las noticias. Por favor, intenta nuevamente.</p>');
        }
      },
      error: function (xhr, status, error) {
        console.error("Error AJAX:", error);
        newsContainer.html('<p class="error-message">Ha ocurrido un error al cargar las noticias. Por favor, intenta nuevamente.</p>');
      },
      complete: function () {
        // Ocultar indicador de carga solo si fue mostrado (primera carga)
        setTimeout(function () {
          newsLoader.hide();
          newsContainer.removeClass("loading");
          isLoading = false;
        }, 300);
      }
    });
  }

  // Manejar clics en los enlaces de paginación
  $(document).on("click", "#news-pagination .pagination-link", function (e) {
    e.preventDefault();
    const page = $(this).data("page");
    loadNews(page);
  });

  // Cargar noticias al cargar la página si el contenedor existe
  $(document).ready(function () {
    if (newsContainer.length > 0) {
      loadNews();
    }
  });
})(jQuery);